var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.282v7.74c0 .247-.05.493-.148.722-.097.23-.24.438-.42.613-.18.176-.395.315-.63.41a1.989 1.989 0 0 1-2.116-.41 1.887 1.887 0 0 1-.42-.613 1.845 1.845 0 0 1-.148-.723M12.5 3.09v1.165",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.938 10.282a3.74 3.74 0 0 0-1.487.304 3.651 3.651 0 0 0-1.232.867 3.673 3.673 0 0 0-1.232-.865 3.76 3.76 0 0 0-2.973 0 3.672 3.672 0 0 0-1.232.865 3.674 3.674 0 0 0-1.314-.9 3.762 3.762 0 0 0-3.13.149A3.647 3.647 0 0 0 4.12 11.72a8.108 8.108 0 0 1 2.7-5.318 8.544 8.544 0 0 1 5.68-2.149c2.104 0 4.13.767 5.682 2.149a8.109 8.109 0 0 1 2.7 5.318 3.629 3.629 0 0 0-1.297-1.06 3.735 3.735 0 0 0-1.647-.378Z",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.d92bb84f.svg";
export { ForwardRef as ReactComponent };